import { useState } from "react";
import { testimonials } from "@/mocks/testimonials";

export default function Testimonial() {
  const [idx, setIdx] = useState(0);
  const t = testimonials[idx];
  return (
    <section className="px-4 md:px-8 py-12 sm:py-16 md:py-24 bg-background-50">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 md:gap-10 items-center">
        <div className="lg:col-span-7 order-2 lg:order-1">
          <div className="flex items-center gap-2 mb-6">
            <span className="w-2 h-2 rounded-full bg-foreground-950"></span>
            <span className="text-[11px] uppercase tracking-[0.18em] text-foreground-700">
              What locals say
            </span>
          </div>
          <blockquote className="relative pl-3 sm:pl-0">
            <span className="absolute -top-4 sm:-top-6 -left-1 sm:-left-2 text-6xl sm:text-7xl md:text-8xl font-heading text-accent-500 leading-none select-none">
              &ldquo;
            </span>
            <p className="text-2xl sm:text-3xl md:text-[46px] font-heading font-medium tracking-tight leading-[1.15] text-foreground-950">
              {t.quote}
            </p>
          </blockquote>
          <div className="mt-8 flex flex-wrap items-center gap-4">
            <div>
              <p className="text-base font-semibold text-foreground-950">
                {t.name}
              </p>
              <p className="text-xs text-foreground-600">{t.postcode}</p>
            </div>
            <span className="w-px h-8 bg-background-300"></span>
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-100 border border-background-200 text-xs text-foreground-800">
              <i className="ri-star-fill text-emerald-500"></i>
              {t.rating}.0 · {t.platform}
            </div>
          </div>
          <div className="mt-8 flex items-center gap-2">
            {testimonials.map((_, i) => (
              <button
                key={i}
                type="button"
                aria-label={`Show testimonial ${i + 1}`}
                onClick={() => setIdx(i)}
                className={`h-2 rounded-full transition-all cursor-pointer ${
                  idx === i ? "w-8 bg-primary-950" : "w-2 bg-background-300 hover:bg-background-400"
                }`}
              />
            ))}
          </div>
        </div>

        <div className="lg:col-span-5 order-1 lg:order-2">
          <div className="rounded-2xl overflow-hidden bg-background-100">
            <img
              src="https://readdy.ai/api/search-image?query=Warm%20candid%20portrait%20of%20a%20friendly%20London%20homeowner%20smiling%20in%20their%20light%20filled%20flat%20living%20room%20with%20wooden%20floors%20and%20green%20plants%2C%20soft%20natural%20window%20light%2C%20realistic%20editorial%20portrait%20photography&width=640&height=800&seq=testimonial-portrait-01&orientation=portrait"
              alt="Local Islington customer smiling"
              loading="lazy" decoding="async"
              className="w-full aspect-[4/5] object-cover object-top"
            />
          </div>
        </div>
      </div>
    </section>
  );
}